import React from "react";
import { connect } from "react-redux";
import { prop, sortBy, isNil } from "ramda";
import { LocalDate } from "js-joda";
import { stringify } from "query-string";
import { MAIN_SECTION } from "../../styles";
import Header from "../../common/components/Header";
import { communicationSelected, searchCommunications } from "./monitorActions";
import CommunicationsTable from "./CommunicationsTable";
import BackToHome from "../../common/components/BackToHome";
import { returnToHome } from "../complianceActions";
import CommunicationsFilter from "./CommunicationsFilter";

class ExploreCommunications extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadCommunications();
    }

    render() {
        return (
            <div style={{width: "1200px", margin: "1em auto"}}>

                <BackToHome onClick={ this.props.onBackToHome }/>

                <div style={Object.assign({}, MAIN_SECTION, {margin: "1em auto"})}>
                    <Header>Explore Communications</Header>

                    <CommunicationsFilter router={this.props.router} location={this.props.location}/>

                    <CommunicationsTable communications={this.props.communications}
                                         onCommunicationChange={this.props.selectCommunication}
                                         selectedCommunication={this.props.selectedCommunication}/>
                </div>
            </div>
        );
    }
}
ExploreCommunications.propTypes = {
    communications: React.PropTypes.array,
    location: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    selectedCommunication: React.PropTypes.string
};

const mapStateToProps = (state, ownProps) => ({
    communications: state.compliance.monitor.searchResults.communications,
    location: ownProps.location,
    router: ownProps.router,
    selectedCommunication: state.compliance.monitor.searchResults.selectedCommunication
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    loadCommunications: () => {
        if (ownProps.location) {
            const { communicatorId, periodStart, periodEnd } = ownProps.location.query;
            if (isNil(communicatorId) && isNil(periodStart) && isNil(periodEnd)) {
                return;
            }
            dispatch(searchCommunications(communicatorId, { periodStart, periodEnd }));
        }
    },
    onBackToHome: () => {
        ownProps.router.push("/compliance");
        dispatch(returnToHome());
    },
    selectCommunication: communicationId => dispatch(communicationSelected(communicationId))
});

const ExploreCommunicationsContainer = connect(mapStateToProps, mapDispatchToProps)(ExploreCommunications);
ExploreCommunicationsContainer.propTypes = {
    router: React.PropTypes.object.isRequired
};

export default ExploreCommunicationsContainer;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/monitor/ExploreCommunications.js
 **/